export default __webpack_public_path__ + "static/media/prototyping.5b6734af.png";